"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Präzisionsfällung",
  description: "Sichere Abtragung von Problembäumen mittels Seilklettertechnik oder Hubsteiger, ohne Schäden an Gebäuden oder Garten.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/photo_2025-11-19_16-24-56-1-e1776847585432.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/photo_2025-11-19_16-24-56-1-e1776847585432.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/photo_2025-11-19_16-24-56-1-e1776847585432.png"
}, {
  title: "Wurzelstockfräsen",
  description: "Effektive Entfernung von Baumstümpfen bis tief ins Erdreich, damit Sie Ihre Fläche sofort neu bepflanzen können.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/rootstock_milling.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/rootstock_milling.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/rootstock_milling.png-wvc-sizes"
}, {
  title: "Baufeldaufräumung",
  description: "Komplette Rodung von Grundstücken als Vorbereitung für Ihr Bauprojekt – schnell, sauber und termingerecht in Hamburg.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/site_clearing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/site_clearing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/site_clearing.png-wvc-sizes"
}];
export default function SpecializedServices() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222527" id="sichere-baumfällung-rodung" className="py-20 px-6 text-foreground !bg-[rgba(232,240,245,1)] md:px-12 lg:px-24" ref={sectionRef}>
      <div className={`max-w-6xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-16">
          <div>
            <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground leading-tight">
              Sichere Baumfällung & Professionelle Rodung
            </h2>
          </div>
          <div className="flex items-center">
            <p className="font-default text-lg md:text-xl text-foreground/90 leading-relaxed">Mit spezialisierter Seilklettertechnik und modernstem Maschinenpark garantieren wir eine sichere Fällung selbst auf engstem Raum in Hamburg und Schleswig Holstein. Wir schützen Ihr Eigentum durch chirurgische Präzision.</p>
          </div>
        </div>

        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
          {services.map((service, i) => <Link key={i} to="/TreeFellingRootRemovalPage" className="group block" data-index={i}>
              <div className="flex flex-col h-full cursor-pointer transition-all duration-300 hover:scale-[1.02] hover:shadow-lg rounded-lg p-2">
                <img src={service.image} data-wvc-srcset={service.srcset} data-wvc-sizes={service.sizes} alt={service.title} className="w-full aspect-video object-cover rounded-lg mb-6 shadow-md" loading="lazy" decoding="async" />
                <h3 className="font-default text-xl font-bold text-foreground mb-4 group-hover:text-primary transition-colors">
                  {service.title}
                </h3>
                <p className="font-default text-base text-foreground/80 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </Link>)}
        </div>

        <div className="mt-16 flex justify-center">
          {}
        </div>
      </div>
    </section>;
}